import {
  AppShell,
  Burger,
  Group,
  NavLink,
  ScrollArea,
  Text,
  ThemeIcon,
  UnstyledButton,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBuildingWarehouse } from '@tabler/icons-react';
import { Link, Outlet, useLocation } from 'react-router';
import { useAuth } from '../../auth/auth-context';
import { GlobalSearch } from './GlobalSearch';
import { NAV_SECTIONS } from './nav-items';
import { UserMenu } from './UserMenu';

const HEADER_HEIGHT = 60;
const NAVBAR_WIDTH = 250;

function isActive(pathname: string, to: string): boolean {
  return to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);
}

export function AppLayout() {
  const [opened, { toggle, close }] = useDisclosure();
  const { can } = useAuth();
  const { pathname } = useLocation();

  return (
    <AppShell
      header={{ height: HEADER_HEIGHT }}
      navbar={{ width: NAVBAR_WIDTH, breakpoint: 'md', collapsed: { mobile: !opened } }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between" wrap="nowrap" gap="sm">
          <Group gap="sm" wrap="nowrap">
            <Burger opened={opened} onClick={toggle} hiddenFrom="md" size="sm" aria-label="Menú" />
            <UnstyledButton component={Link} to="/" visibleFrom="xs" aria-label="Inicio">
              <Group gap={8} wrap="nowrap">
                <ThemeIcon size="lg" radius="md">
                  <IconBuildingWarehouse size={20} />
                </ThemeIcon>
                <Text fw={700} size="lg">
                  Almacén
                </Text>
              </Group>
            </UnstyledButton>
          </Group>
          {can('pallets.read') && <GlobalSearch />}
          <UserMenu />
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="xs">
        <ScrollArea>
          {NAV_SECTIONS.map((section) => {
            const items = section.items.filter((item) => can(item.permission));
            if (items.length === 0) return null;
            return (
              <div key={section.title}>
                <Text size="xs" fw={700} c="dimmed" tt="uppercase" px="sm" mt="sm" mb={4}>
                  {section.title}
                </Text>
                {items.map((item) => (
                  <NavLink
                    key={item.to}
                    component={Link}
                    to={item.to}
                    label={item.label}
                    leftSection={<item.icon size={20} stroke={1.6} />}
                    active={isActive(pathname, item.to)}
                    onClick={close}
                    styles={{ label: { fontSize: 15 } }}
                  />
                ))}
              </div>
            );
          })}
        </ScrollArea>
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
